import React from 'react';
import './index.scss';

class OpenNoticeGuidDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    return (
			<div className="openNoticeGuidDialog">
				<div className="dialog">
					<div className="close"></div>
					<div className="title">如何开启提醒</div>
					<div className="step">１进入系统设置找到权限管理</div>
					<div className="step">２选择并进入【看点快报】</div>
					<div className="step">３找到【通知】并打开</div>
					<div className="openBtn">立即开启</div>
				</div>
			</div>
    );
  }
}

export default OpenNoticeGuidDialog;
